import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type InvoiceEntryLaunchState = {
    carrierId: string;
    invoiceNum: string;
};

const baseSessionState = {
    carrierId: '',
    invoiceNum: '',
} as InvoiceEntryLaunchState;

const slice = createSlice({
    name: 'invoiceEntryLaunch',
    initialState: baseSessionState,
    reducers: {
        setLaunchInfo: (
            state,
            action: PayloadAction<InvoiceEntryLaunchState>
        ) => {
            state.carrierId = action.payload.carrierId;
            state.invoiceNum = action.payload.invoiceNum;
        },
        clearLaunchInfo: (state) => {
            state.carrierId = '';
            state.invoiceNum = '';
        },
    },
});

export const {setLaunchInfo, clearLaunchInfo} = slice.actions;

export default slice.reducer;
